export const pct = (v) => (v == null ? "—" : `${Number(v).toFixed(Number.isInteger(Number(v)) ? 0 : 1)}%`);

export const pts = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(1)} pts`);

export const KIND_LABEL = { pilot: "Pilot", commercial: "Commercial" };

export const daysLabel = (p) => {
  const d = p.days_since_start;
  if (d < 0) return `Starts in ${-d} day${d === -1 ? "" : "s"}`;
  return p.ended ? `Ran ${d} day${d === 1 ? "" : "s"}` : `${d} day${d === 1 ? "" : "s"} since start`;
};

export const groupByClient = (list) => {
  const groups = {};
  list.forEach((p) => {
    const key = p.client_id || "__none";
    (groups[key] = groups[key] || { name: p.client_name || "Client removed", projects: [] }).projects.push(p);
  });
  return Object.entries(groups).sort(([a, x], [b, y]) => (a === "__none") - (b === "__none") || x.name.localeCompare(y.name));
};
